module.exports = __webpack_public_path__ + "static/beauty7-6ee12de77c35dfbe438d5157fc0fe7c8.jpg";